import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

// Phone-only "Book Now" pinned above the thumb; appears once the hero's own CTA has scrolled away
export const MobileBookBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-[max(env(safe-area-inset-bottom),0.75rem)] pt-2 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/95 to-transparent transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
      data-testid="mobile-book-bar" aria-hidden={!show}>
      <Link to="/booking" tabIndex={show ? 0 : -1}
        className="flex items-center justify-center gap-2 h-12 rounded-full bg-teal-500 text-black font-heading font-bold text-base shadow-[0_0_24px_rgba(0,240,255,0.45)] active:scale-95 transition-transform"
        data-testid="mobile-book-now-btn">
        <Sparkles className="w-4 h-4" /> Book Now — from £50
      </Link>
    </div>
  );
};
